import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

const SelectCheckbox = ({ id, name, value, onChange, onBlur, disabled, options }) => (
  <select
    {...{
      id,
      name,
      value: value || '',
      onChange,
      onBlur,
      disabled,
    }}
  >
    {R.map(
      opt => (
        <option key={opt.label} value={opt.value}>
          {opt.label}
        </option>
      ),
      [{ label: 'Choose...' }].concat(options)
    )}
  </select>
);

SelectCheckbox.PropTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.array.isRequired,
};

export default SelectCheckbox;
